export const RouteNames = {
  HOME: '/',
  PROJECT_SITE_HOME: '/:projectId/:siteId',
  LOGIN: '/login',
  AZURE_CALLBACK: '/public/oauth',
  CIAM_CALLBACK: '/public/coauth',
  NOT_FOUND: '*',

  // Dashboard routes with project and site context
  DASHBOARD_STORAGE: '/:projectId/:siteId/dashboard/storage-overview',
  DASHBOARD_TRANSPORT: '/:projectId/:siteId/dashboard/transport-overview',
  DASHBOARD_SERVICE_USERS: '/:projectId/:siteId/dashboard/service-users',
  DASHBOARD_MAPPING: '/:projectId/:siteId/dashboard/mapping',

  CONSIGNMENTS: '/:projectId/:siteId/requests',
  CONSIGNMENT_NEW: '/:projectId/:siteId/consignments/new',
  CONSIGNMENT_EDIT: '/:projectId/:siteId/consignments/:consignmentId/edit',
  SERVICE_REQUESTS: '/:projectId/:siteId/service-requests',
  // Matches the backend-served menu item (code `DLV`, path `/receives`) — the
  // Receives entry is dynamic (from the layout API), not a static menu item.
  RECEIVE: '/:projectId/:siteId/receives',
  // Receive History sub-page of the Receive group; the menu sub-item is also
  // dynamic (from the layout API), the FE only provides the matching route.
  RECEIVE_HISTORY: '/:projectId/:siteId/receive-history',
  // Lost or Not Sent Items sub-page of the Receive group (menu code
  // `RECEIVE_LOSSES`); the menu sub-item is dynamic (from the layout API), the
  // FE only provides the matching route.
  RECEIVE_LOSSES: '/:projectId/:siteId/receive-losses',
  // In-progress Dispatches sub-page of the Dispatch group (menu code
  // `DISPATCH_IN_PROGRESS`); the menu sub-item is dynamic (from the layout
  // API), the FE only provides the matching route.
  DISPATCH_IN_PROGRESS: '/:projectId/:siteId/dispatch-in-progress'
} as const;

export type RouteNames = (typeof RouteNames)[keyof typeof RouteNames];

/**
 * Pages that make up the Consignments section of the menu. Both are sub-items
 * of the same menu group, so indicators scoped to the section stay visible
 * while the user moves between them.
 */
export const CONSIGNMENTS_SECTION_ROUTES: string[] = [RouteNames.CONSIGNMENTS, RouteNames.SERVICE_REQUESTS];
